import { useABTesting } from '@/hooks/abTesting';
import useEstonia from '@/hooks/estonia';
import { useCommonStore } from '@/store';

export enum ExpGoogleRegformLU {
  A = 'a_google_signin2_regform_lu',
  B = 'b_google_signin2_regform_lu',
}

export const useGoogleRegistrationABTest = () => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const { isEstonia } = useEstonia();

  const isGoogleRegAvailable =
    useABTesting('exp_google_signin2_regform_lu', {
      defaultVersion: ExpGoogleRegformLU.A,
      versions: [
        { name: ExpGoogleRegformLU.A, probability: 50 },
        { name: ExpGoogleRegformLU.B, probability: 50 },
      ],
      turnOffTest: isEstonia || isAuthenticated,
    }) === ExpGoogleRegformLU.B;

  return isGoogleRegAvailable;
};
